
import AmpereIcon from "@/pages/aigc/assets/svg/ampere-active.svg";
import _databarin from '@/pages/aigc/assets/svg/databrain-source.png';
import _databarin_active from '@/pages/aigc/assets/svg/databrain-source-active.png';

import { getDataSourceIcon } from '@intelligence/utils/getDataSourceImg';


const DbiImgMap: { [key: string]: string; } = {
  _ampere: AmpereIcon,
  _databrain: _databarin,
};


const agentSourceIconMap: Record<string, string> = {
  _mixed: _databarin,
  _databrain: _databarin_active,
};

export const getDataSourceActiveIcon = (code: string) => {
  if (typeof code !== 'string') return '';
  const imgCode = `_${code?.toLowerCase()?.trim()}`;
  return DbiImgMap?.[imgCode];
};

// 获取agent数据源icon，如果agent数据源iconMap有，则返回agent数据源iconMap的icon，否则返回intelligence数据源icon
export const getAgentSourceIcon = (value: string) => {
  const code = `_${value?.toLowerCase()?.trim()?.replace(/\s+/g, '')}`;
  if (agentSourceIconMap?.[code]) {
    return agentSourceIconMap[code];
  }
  return getDataSourceIcon(value);
};


